


































































import { Component, Vue } from 'vue-property-decorator'
import { MungBeanAllocateBatchDetail } from '@/api'

@Component
export default class MungBeanAllocateBatchDetailDialog extends Vue {
  private show = false
  private loading = false
  private errorMsg = ''
  private detail: any = null

  public async open(data: any) {
    const batchNo = data && data.batchNo
    if (!batchNo) {
      return
    }
    this.show = true
    this.loading = true
    this.errorMsg = ''
    this.detail = null
    try {
      const res = await MungBeanAllocateBatchDetail({ batchNo })
      if (!res) {
        this.errorMsg = '加载批次详情失败'
        return
      }
      this.detail = {
        ...res,
        statusLabel: res.status === 1 ? '成功' : res.status === 0 ? '处理中' : String(res.status),
      }
    } catch (e: any) {
      this.errorMsg = (e && e.message) || '加载失败'
    } finally {
      this.loading = false
    }
  }

  private close() {
    this.show = false
    this.detail = null
    this.errorMsg = ''
  }
}
